module.exports = __webpack_public_path__ + "static/media/53_tn.7292fede.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/53_tn.jpg
// module id = 689
// module chunks = 0